/** Where one finger is, in the window's pixels. */
export interface ScreenPoint {
  xPixels: number;
  yPixels: number;
}

/** Two fingers on the board, reduced to what a pinch is measured by. */
export interface PinchSpan {
  distancePixels: number;
  midpoint: ScreenPoint;
}

export const measurePinchSpan = ([first, second]: readonly [ScreenPoint, ScreenPoint]) => ({
  distancePixels: Math.hypot(second.xPixels - first.xPixels, second.yPixels - first.yPixels),
  midpoint: {
    xPixels: (first.xPixels + second.xPixels) / 2,
    yPixels: (first.yPixels + second.yPixels) / 2,
  },
});

/**
 * One step of a pinch: how much the board zooms, about which point, and how far
 * it moves.
 *
 * Zoomed about the point between the fingers and moved by how far that point
 * travelled, so what was under the fingers stays under them - the board follows
 * the hand, as a photo on a phone does. A step from fingers that started on top
 * of each other has no distance to scale, and zooms by nothing.
 */
export const resolvePinchStep = ({ previous, next }: { previous: PinchSpan; next: PinchSpan }) => ({
  factor: previous.distancePixels > 0 ? next.distancePixels / previous.distancePixels : 1,
  about: next.midpoint,
  pan: {
    xPixels: next.midpoint.xPixels - previous.midpoint.xPixels,
    yPixels: next.midpoint.yPixels - previous.midpoint.yPixels,
  },
});
